/**
 * The homepage has no slug: it lives at the locale root (`/es`, `/fr`), so `slugs` is empty and the
 * SEO helper switches to its pathless mode. `routeName` is '' for the same reason.
 */
export const routeName = '';
export const slugs: Record<string, string> = {};
export const sitemap = { changefreq: 'weekly', priority: '1.0', lastmod: '2026-08-21' };
